import {Component, Input, OnInit} from '@angular/core';
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'btx-check-box',
  templateUrl:'./btx-check-box.component.html',
  styleUrls: ['./btx-check-box.component.scss'],
  standalone: false
})
export class BtxCheckBoxComponent implements OnInit {


  @Input()
  field: FieldConfig | any;

  @Input()
  group: FormGroup | any;


  constructor() {
  }

  ngOnInit(): void {
  }

}
